
import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, Linkedin, Mail, Phone, MapPin } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-muted/30 border-t border-border">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center mb-4">
              <img 
                src="/lovable-uploads/9c04ed46-f154-45c9-97e2-769141c63229.png" 
                alt="TeenVisor Logo" 
                className="h-8 w-8 rounded-md"
              />
              <span className="ml-2 text-xl font-bold">TeenVisor</span>
            </div>
            <p className="text-muted-foreground mb-4">
              Empowering teens to discover their potential through mentorship, career exploration, and meaningful connections.
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://www.instagram.com/_teenvisor_/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-primary transition-colors"
              >
                <Instagram size={20} />
                <span className="sr-only">Instagram</span>
              </a>
              <a 
                href="https://www.linkedin.com/company/teenvisor" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-primary transition-colors"
              >
                <Linkedin size={20} />
                <span className="sr-only">LinkedIn</span>
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="text-muted-foreground hover:text-primary">Home</Link></li>
              <li><Link to="/explore" className="text-muted-foreground hover:text-primary">Discover Your Career Path</Link></li>
              <li><Link to="/mentors" className="text-muted-foreground hover:text-primary">Find Mentors</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-semibold mb-4">Resources</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a 
                  href="https://nas.io/teenvisor" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-muted-foreground hover:text-primary"
                >
                  Join Our Community
                </a>
              </li>
              <li><Link to="/become-mentor" className="text-muted-foreground hover:text-primary">Become a Mentor</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-semibold mb-4">Contact Us</h3>
            <div className="space-y-4">
              <div className="flex items-center gap-3 text-sm">
                <div className="h-8 w-8 bg-primary/10 rounded-full flex items-center justify-center">
                  <Mail size={16} className="text-primary" />
                </div>
                <div>
                  <p className="text-muted-foreground text-xs">Email</p>
                  <a href="mailto:teenvisor@gmail.com" className="text-foreground hover:text-primary font-medium">
                    teenvisor@gmail.com
                  </a>
                </div>
              </div>
              <div className="flex items-center gap-3 text-sm">
                <div className="h-8 w-8 bg-primary/10 rounded-full flex items-center justify-center">
                  <Phone size={16} className="text-primary" />
                </div>
                <div>
                  <p className="text-muted-foreground text-xs">Phone</p>
                  <a href="tel:+919994342931" className="text-foreground hover:text-primary font-medium">
                    +91 9994342931
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="border-t border-border mt-8 pt-6 flex flex-col md:flex-row items-center justify-between">
          <p className="text-xs text-muted-foreground mb-4 md:mb-0">
            © {new Date().getFullYear()} TeenVisor. All rights reserved.
          </p>
          <div className="flex space-x-6 text-xs">
            <Link to="/privacy" className="text-muted-foreground hover:text-primary">Privacy Policy</Link>
            <Link to="/terms" className="text-muted-foreground hover:text-primary">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
